/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupportPortalDto
 */
export interface SupportPortalDto {
    /**
     * URL to the customer support portal
     * @type {string}
     * @memberof SupportPortalDto
     */
    url: string;
}

/**
 * Check if a given object implements the SupportPortalDto interface.
 */
export function instanceOfSupportPortalDto(value: object): value is SupportPortalDto {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function SupportPortalDtoFromJSON(json: any): SupportPortalDto {
    return SupportPortalDtoFromJSONTyped(json, false);
}

export function SupportPortalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportPortalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function SupportPortalDtoToJSON(json: any): SupportPortalDto {
    return SupportPortalDtoToJSONTyped(json, false);
}

export function SupportPortalDtoToJSONTyped(value?: SupportPortalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

